module.exports = __webpack_public_path__ + "static/media/DJ.233bb83a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/DJ.svg
// module id = 2139
// module chunks = 7